export type CustomerDiscountType = 'percentage' | 'flat';

export interface CustomerDiscountInfo {
  discount_type?: CustomerDiscountType | string | null;
  discount_value?: number | null;
  original_amount?: number;
  discounted_amount?: number;
  discount_amount?: number;
}

export class CustomerDiscountUtils {
  static hasDiscount(d?: CustomerDiscountInfo | null): boolean {
    if (!d || !d.discount_type || d.discount_value == null) {
      return false;
    }
    const value = Number(d.discount_value);
    return !isNaN(value) && value > 0;
  }

  static formatLabel(d?: CustomerDiscountInfo | null): string | null {
    if (!CustomerDiscountUtils.hasDiscount(d)) {
      return null;
    }
    const value = Number(d.discount_value);
    if (d.discount_type === 'percentage') {
      return `${value}%`;
    }
    if (d.discount_type === 'flat') {
      return `$${value.toFixed(2)} flat`;
    }
    return null;
  }

  static preview(amount: number, d?: CustomerDiscountInfo | null): {
    original: number;
    discounted: number;
    saved: number;
  } | null {
    if (!CustomerDiscountUtils.hasDiscount(d)) {
      return null;
    }
    const original = Number(amount);
    if (isNaN(original) || original < 0) {
      return null;
    }
    const value = Number(d.discount_value);
    let discounted = original;
    if (d.discount_type === 'percentage') {
      discounted = original * (1 - value / 100);
    } else if (d.discount_type === 'flat') {
      discounted = Math.max(0, original - value);
    } else {
      return null;
    }
    discounted = Math.round(discounted * 100) / 100;
    const saved = Math.round((original - discounted) * 100) / 100;
    return { original, discounted, saved };
  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/CustomerDiscount/CustomerDiscountUtils.ts